import { Icon, Text } from '@cencosud-cencommerce/paris-uikit';

interface ShowDetailsProps {
  setModalOpen: (value: boolean) => void;
}

const ShowDetails = ({ setModalOpen }: ShowDetailsProps) => {
  const handleClick = () => setModalOpen(true);

  return (
    <div className="co-flex co-self-center co-gap-2" onClick={handleClick}>
      <div className="co-flex co-text-end">
        <Text variant="link1" color="primary-500" weight={600}>
          Mostrar detalle
        </Text>
      </div>
      <Icon name="arrow-right" fill="primary-500" />
    </div>
  );
};

export default ShowDetails;
